export interface ResponseList<T> {
    totalPages: number; // всего страниц
    totalElements: number; // всего элементов
    number: number; // номер текущей страницы
    numberOfElements: number; // кол-во элементов на текущей странице
    content: T[];
}
